// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__IcwNM","matchBlock":"styles_matchBlock__1gBBu","input":"styles_input__2Rwon"};